import React from 'react';
import { useQuery, useMutation } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { Coins, Star, Loader2, Check } from 'lucide-react';
import { Button } from '../ui/button';
import paymentService, { CreditPackage } from '../../services/paymentService';

interface CreditPackagesProps {
  className?: string;
}

const CreditPackages: React.FC<CreditPackagesProps> = ({ className = '' }) => {
  // Hide credit packages as requested
  return null;
};

export default CreditPackages;